module.exports = __webpack_public_path__ + "static/media/introduce_p10@2x.f93418c0.png";